import React, { useEffect, useRef } from "react";
import ImageWithBasePath from "../../../core/data/img/ImageWithBasePath";
import { useSelector } from "react-redux";

const StepSecond = ({
  formik,
  otp,
  setOtp,
  isOtpComplete,
  error,
  handleResendOTP,
  loading,
  countdown,
  setCountdown,
}: any) => {
  const inputsRef = useRef<Array<HTMLInputElement | null>>([]);
  const userDetail = useSelector((state: any) => state.user?.userDetail);
  const phone = userDetail?.phone || localStorage.getItem("phone");
  const maskedPhone = phone ? phone.slice(-4) : "";
  const email = userDetail?.email || localStorage.getItem("remember_email") || localStorage.getItem("email");
  // Initialize countdown when component mounts
  useEffect(() => {
    setCountdown(60); // Start countdown on mount
  }, []);

  // handle OTP input change
  const handleChange = (value: string, index: number) => {
    const newOtp = [...otp];
    newOtp[index] = value.replace(/\D/g, ""); // allow only digits
    setOtp(newOtp);

    // move focus to next if value entered
    if (value && index < 5) {
      inputsRef.current[index + 1]?.focus();
    }
  };

  // handle backspace navigation
  const handleBackspace = (index: number, value: string) => {
    if (value === "" && index > 0) {
      inputsRef.current[index - 1]?.focus();
    }
  };

  // Format countdown text
  const countdownText = countdown > 0 ? `after ${countdown} seconds` : "";

  return (
    <div className="main-wrapper authendication-pages step_second">
      <div className="content">
        <div className="container wrapper no-padding">
          <div className="row no-margin  align-items-stretch">
            <div className="col-12 col-sm-12 col-md-12 col-lg-8 no-padding d-flex">
              <div className="banner-bg banner-bg-1 login">
                <div className="row h100">
                  <div className="col-sm-12 col-md-12 col-lg-12">
                    <div className="row h-100">
                      <div className="col-md-12 h-100">
                        <img
                          src="/assets/img/authImg.jpg"
                          className="object-fit-cover img-fluid w-100"
                          alt="authImg"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-12 col-sm-12 col-md-12 col-lg-4 no-padding">
              <div className="dull-pg shadow-card w-100">
                <div className="row no-margin d-flex align-items-top justify-content-center">
                  <div className="col-sm-10 col-md-10 col-lg-11 mx-auto">
                    <div className=" d-flex align-top justify-content-center flex-wrap">
                      <div className="shadow-card-inner">
                        <header className="text-center position-relative">
                          <ImageWithBasePath
                            src="assets/img/logo.svg"
                            className="img-fluid"
                            alt="Logo"
                          />
                        </header>

                        <h2 className="text-center ">
                          We sent a text to your phone
                        </h2>
                        <p className="text-center">
                          To continue, please enter the 6-digit verification code sent to your
                          <strong> registered phone number (ending in {maskedPhone})</strong> and
                          <strong> email address ({email})</strong>.
                        </p>
                        <p className="text-center">
                          Code are valid for 10 minutes.
                        </p>
                        <div className="tab-content" id="myTabContent">
                          <div
                            className="tab-pane fade show active"
                            id="user"
                            role="tabpanel"
                            aria-labelledby="user-tab"
                          >
                            <form
                              autoComplete="off"
                              onSubmit={formik.handleSubmit}
                            >
                              <div className="form-group OtpForm">
                                <div className="d-flex groupInputs justify-content-center">
                                  {otp.map((digit: any, index: any) => (
                                    <input
                                      className={error ? "border-warning" : ""}
                                      key={index}
                                      type="text"
                                      placeholder="_"
                                      maxLength={1}
                                      value={digit}
                                      ref={(el) =>
                                        (inputsRef.current[index] = el)
                                      }
                                      onChange={(e) =>
                                        handleChange(e.target.value, index)
                                      }
                                      onKeyDown={(e) => {
                                        if (e.key === "Backspace") {
                                          handleBackspace(
                                            index,
                                            e.currentTarget.value
                                          );
                                        }
                                      }}
                                      onPaste={(e) => {
                                        e.preventDefault();
                                        const paste = e.clipboardData
                                          .getData("text")
                                          .replace(/\D/g, ""); // only digits
                                        if (paste.length === 6) {
                                          setOtp(paste.split("")); // fill all boxes
                                          inputsRef.current[5]?.focus(); // move to last input
                                        }
                                      }}
                                    />
                                  ))}
                                </div>
                                {error && (
                                  <p className="text-center mt-2 text-warning">
                                    ⚠ {error}
                                  </p>
                                )}
                              </div>

                              <button
                                type="submit"
                                className="btn primaryButton  btn-primary d-inline-flex justify-content-center align-items-center w-100 btn-block"
                                disabled={loading || !isOtpComplete}
                              >
                                Verify
                              </button>
                            </form>

                            <p className="text-center">
                              Didn’t receive the auth code?{" "}
                              <button
                                onClick={handleResendOTP}
                                disabled={countdown > 0 || loading}
                                className={countdown > 0 ? "disabled-link" : ""}
                              >
                                Re-Send
                              </button>{" "}
                              {countdownText && <span>{countdownText}</span>}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StepSecond;
